import type { GameHistoryApiType } from "./useDiscoverGameHistoryFeed";
import { GameHistoryNoteItemType } from "./constants";
import { _ } from "i18n";

export const GameHistorySubTabId = {
	All: "all",
	InternalNotes: "internal_notes",
	Logs: "logs",
} as const;

export type GameHistorySubTab = (typeof GameHistorySubTabId)[keyof typeof GameHistorySubTabId];

export type GameHistoryI18nKey = Parameters<typeof _>[0];

export const GAME_HISTORY_SUB_TAB_API_TYPE: Record<GameHistorySubTab, GameHistoryApiType> = {
	[GameHistorySubTabId.All]: "all",
	[GameHistorySubTabId.InternalNotes]: GameHistoryNoteItemType.Internal,
	[GameHistorySubTabId.Logs]: GameHistoryNoteItemType.Log,
};

export function gameHistoryShowsAddForm(subTab: GameHistorySubTab): boolean {
	return subTab === GameHistorySubTabId.All || subTab === GameHistorySubTabId.InternalNotes;
}

export function gameHistoryEmptyMessageKey(subTab: GameHistorySubTab): GameHistoryI18nKey {
	return subTab === GameHistorySubTabId.Logs
		? "discover.gameDetail.history.noLogs"
		: "discover.gameDetail.history.noNotes";
}
